/**
 * Dates, formatted once.
 *
 * Every caller used to build its own `new Date(x).toLocaleString(...)`, which
 * meant a null or an unparseable value rendered the literal string
 * "Invalid Date" in the interface. There is no reading of "Invalid Date" that
 * helps anyone; the useful output is a dash.
 */
const EM_DASH = '—';

const parse = (value: string | number | Date | null | undefined): Date | null => {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value: string | number | Date | null | undefined): string => {
  const date = parse(value);
  return date
    ? date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })
    : EM_DASH;
};

export const formatDateTime = (value: string | number | Date | null | undefined): string => {
  const date = parse(value);
  return date
    ? date.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : EM_DASH;
};

export const formatDayMonth = (value: string | number | Date | null | undefined): string => {
  const date = parse(value);
  return date ? date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) : EM_DASH;
};
